var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGnbNotification = function SvgGnbNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.645 20.147v-8.043a7.355 7.355 0 0 1 7.356-7.355v0a7.355 7.355 0 0 1 7.355 7.355v8.043m-14.71 0h14.71m-14.71 0H4.75m16.606 0h1.894M10.7 22.898h6.6"
  })));
};
export default SvgGnbNotification;